export default __webpack_public_path__ + "static/media/116-BZ-500.d8157aee.png";